import { render, staticRenderFns } from "./RegulatoryRollCall.vue?vue&type=template&id=566c68bd"
import script from "./RegulatoryRollCall.vue?vue&type=script&lang=js"
export * from "./RegulatoryRollCall.vue?vue&type=script&lang=js"
import style0 from "./RegulatoryRollCall.vue?vue&type=style&index=0&id=566c68bd&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports